// extracted by css-extract-rspack-plugin
export default {"container":"CopilotCodingAgentQuotaBanner-module__container__RqXJG"};